import React, { useMemo } from "react";

const sanitize = (value) => (typeof value === "string" ? value.trim() : "");

// Helper to extract image URL from API response
const getImageUrl = (imageField) => {
    if (!imageField) return null;
    // Priority: url > 2048x2048 > large > 1536x1536 > medium_large
    return imageField.url ||
           imageField.sizes?.['2048x2048'] ||
           imageField.sizes?.large ||
           imageField.sizes?.['1536x1536'] ||
           imageField.sizes?.medium_large ||
           null;
};

const SimpleBannerSection = ({ fields }) => {
    const sanitizedData = useMemo(() => {
        if (!fields) {
            return null;
        }

        // Support multiple field name variations
        const title = sanitize(fields.title || fields.heading || "");
        const subtitle = sanitize(fields.subtitle || fields.description || "");
        const eyebrow = sanitize(fields.eyebrow || "");

        // Extract background image - support both background_image and image fields
        const backgroundImage = getImageUrl(fields.background_image || fields.image);
        const backgroundImageMobile = getImageUrl(fields.background_image_mobile);

        // At least title or subtitle should be present
        const hasContent = title || subtitle || eyebrow;
        if (!hasContent && !backgroundImage) {
            return null;
        }

        return {
            title,
            subtitle,
            eyebrow,
            backgroundImage,
            backgroundImageMobile,
        };
    }, [fields]);

    if (!sanitizedData) return null;

    const { title, subtitle, eyebrow, backgroundImage, backgroundImageMobile } = sanitizedData;

    return (
        <div className="know-before_hero" data-stagger-index="0">
            <div 
                className="know-before_hero_image aos-fade-up" 
                data-stagger-index="0"
            >
                {/* Desktop image */}
                {backgroundImage && (
                    <img 
                        src={backgroundImage}
                        alt={fields?.background_image?.alt || fields?.image?.alt || `${title || "Banner"} - Background`}
                        className="simple_banner_bg_img simple_banner_bg_img_desktop"
                        fetchPriority="high"
                        loading="eager"
                    />
                )}
                {/* Mobile image */}
                {backgroundImageMobile && (
                    <img 
                        src={backgroundImageMobile}
                        alt={fields?.background_image_mobile?.alt || `${title || "Banner"} - Background Mobile`}
                        className="simple_banner_bg_img simple_banner_bg_img_mobile"
                        fetchPriority="high"
                        loading="eager"
                    />
                )}
                
                <div className="know-before_hero_overlay">
                    <div className="container">
                        <div className="know-before-overlay-content" data-stagger-index="0">
                        {/* Eyebrow text (small text above title) */}
                        {eyebrow && (
                            <p style={{ 
                                fontSize: '14px', 
                                fontWeight: 500, 
                                color: '#FFFFFF', 
                                opacity: 0.8,
                                marginBottom: '8px',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px'
                            }}>{eyebrow}</p>
                        )}
                        
                        {/* Main title */}
                        {title && <h1>{title}</h1>}
                        
                        {/* Subtitle/Description */}
                        {subtitle && (
                            <p style={{ 
                                marginTop: title ? '10px' : '0',
                                color: '#FFFFFF', 
                                fontSize: '18px', 
                                lineHeight: '26px',
                                opacity: 0.7,
                                maxWidth: '450px'
                            }}>{subtitle}</p>
                        )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SimpleBannerSection;

